export const getDebug = (store) => store.debug;

export const getShowTranslationKeys = (store) => getDebug(store).showTranslationKeys;
